import { css } from '@emotion/css';
import { RootState, useAppDispatch, useAppSelector } from 'cache/store';
import { appName } from 'config/app.config';
import { colors } from 'constants/theme';
import { toggleFastLotteryHome } from 'features/configSlice';
import { forwardRef, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Tooltip } from 'react-tooltip';
import { scrollToTopPage } from 'utils/function';

const supportList = [
    {
        name: '',
        id: 'CLOSEHELP',
        icon: require('assets/images/header/arrow.svg'),
    },
    {
        name: 'CSKH',
        id: 'CSKH',
        icon: require('assets/images/header/cskh.svg'),
    },
    {
        name: 'Telegram',
        id: 'TELEGRAM',
        icon: require('assets/images/header/telegram.svg'),
    },
    {
        name: 'Zalo',
        id: 'ZALO',
        icon: require('assets/images/header/zalo.svg'),
    },
    {
        name: 'Tải App',
        id: 'DOWNLOAD',
        icon: require('assets/images/header/down-app.svg'),
    },
    {
        name: 'SpeedTest',
        id: 'SPEEDTEST',
        icon: require('assets/images/header/speedtest.svg'),
    },
];
const sapcingTop = 240;

interface Props {}

function SupportArea(props: Props, ref: any) {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const { triggerFastLottery } = useAppSelector((state: RootState) => state.config);
    const [positionArea, setPositionArea] = useState(sapcingTop);
    const [isMenu, setIsMenu] = useState(false);

    useEffect(() => {
        if (ref.current) {
            ref.current.addEventListener('scroll', listenerEventScroll);

            return () => {
                if (ref.current) {
                    ref.current.removeEventListener('scroll', listenerEventScroll);
                }
            };
        }
    }, [triggerFastLottery]);

    const listenerEventScroll = (event: Event) => {
        var element: any = event.target;
        if (element.scrollTop <= sapcingTop) {
            const value = sapcingTop - element.scrollTop;
            setPositionArea(value);
        } else {
            setPositionArea(0);
        }
        if (element.scrollTop > 800) {
            if (!triggerFastLottery) {
                dispatch(toggleFastLotteryHome(true));
            }
        }
    };

    const selectPage = (id: string) => {
        if (id === 'DOWNLOAD') {
            navigate('/download');
            scrollToTopPage();
        } else if (id === 'CLOSEHELP') {
            setIsMenu(!isMenu);
        } else if (id === 'SPEEDTEST') {
            window.open('https://188lux.online/');
        } else if (id === 'CSKH' && (window as any).LC_API) {
            (window as any).LC_API.open_chat_window();
        } else if (id === 'TELEGRAM') {
            const random = Math.random() < 0.5;
            window.open(random ? 'https://t.me/CSKH_188lux' : 'https://t.me/CSKH_188lux', '_blank');
        }
    };
    return (
        <div className={`${styles.support} ${isMenu ? "isHidenMenu" : ""}`} style={{ top: `${positionArea}px` }}>
            {supportList.map((item) => (
                <div className={styles.supportItem} key={item.id} onClick={() => selectPage(item.id)} data-tooltip-id={item.id} data-tooltip-place="left" data-tooltip-class-name={styles.tooltipWrap}>
                    <img className='imgsp' src={item.icon.default} alt="" />
                    <p>{item.name}</p>
                </div>
            ))}

            <Tooltip id="TELEGRAM">
                <div className={styles.baseTele}>
                    <div className="tele-item">
                        <p>@CSKH_{appName}</p>
                    </div>
                </div>
            </Tooltip>

            <Tooltip id="ZALO">
                <div className={styles.baseTele}>
                    <div className="tele-item">
                        <img src={require('assets/images/icons/home/qr-zalo.png')} alt="" />
                    </div>
                </div>
            </Tooltip>

            <Tooltip id="DOWNLOAD">
                <div className={styles.baseTele}>
                    <div className="tele-item">
                        <img src={require('assets/images/icons/home/qr-android.jpg')} alt="" />
                        <p>Android</p>
                    </div>
                    <div className="tele-item">
                        <img src={require('assets/images/icons/home/qr-ios.jpg')} alt="" />
                        <p>iOS</p>
                    </div>
                </div>
            </Tooltip>
        </div>
    );
}

const styles = {
    support: css`
        position: fixed;
        right: -2px;
        z-index: 10;
        border-radius: 0 0 0 12px;
        background: linear-gradient(to bottom, #002DB2, #002181);
        padding: 2px 0;
        transform: scale(0.8);
        &.isHidenMenu {
            height: 65px;
            right: -56px;
            top: 50% !important;
            transform: scale(0.6);
            img {
                transform: rotate(180deg);
            }
            &:hover {
                transform: scale(0.8);
            }
        }
    `,
    supportItem: css`
        cursor: pointer;
        text-align: center;
        padding: 4px 12px 8px;
        display: flex;
        flex-direction: column;
        position: relative;
        justify-content: center;
        align-items: center;
        &:hover {
            box-shadow: inset 0 0 30px #547dff;
            .imgsp {
                filter: brightness(0) saturate(100%) invert(74%) sepia(85%) saturate(700%) hue-rotate(1deg) brightness(105%) contrast(105%);
            }
            p {
                color: #ffe100;
            }
        }
        &:first-child {
            padding: 10px;
            position: absolute;
            right: 68px;
            background: linear-gradient(to right, #002DB2, #002181);
            border-radius: 5px 0 0 5px;
            top: 0;
            &:before {
                content: none;
            }
            img {
                width: 22px;
            }
        }
        &:last-child {
            &:before {
                content: none;
            }
        }
        &:before {
            content: "";
            position: absolute;
            bottom: 0;
            width: 80%;
            left: 10%;
            border-bottom: 1px solid #167BF0;
            height: 1px;
        }
        p {
            font-size: 10px;
            color: ${colors.white};
        }
        .imgsp {
            width: 40px;
        }
    `,
    tooltipWrap: css`
        background: ${colors.white} !important;
        padding: 8px !important;
        border-radius: 8px !important;
        opacity: 1 !important;
    `,
    baseTele: css`
        background: ${colors.white};
        display: flex;
        gap: 8px;
        .tele-item {
            text-align: center;
            img {
                width: 150px;
            }
            p {
                color: ${colors.bgPopupDrak};
                font-weight: 600;
                font-size: 20px;
            }
        }
    `,
};

export default forwardRef(SupportArea);
